// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { SessionDocument } from "./documents/session-document";
import { ItemEnvelope } from "./base/item-envelope";

export class SessionEnvelope extends ItemEnvelope {
	public constructor(jsonEnvelope: any) {
		super(jsonEnvelope, "Session");
		if (jsonEnvelope) {
			this.Document = jsonEnvelope.Document;
			this.CreatedOnUTC = jsonEnvelope.CreatedOnUTC;
			this.CreateUserUID = jsonEnvelope.CreateUserUID;
			this.ModifiedOnUTC = jsonEnvelope.ModifiedOnUTC;
			this.ModifyUserUID = jsonEnvelope.ModifyUserUID;
		}
	}
	public override Document: SessionDocument = new SessionDocument();
	public override get ItemId(): number { return this.Document.Item.SessionId; }
	public override get ItemName(): string { return this.Document.Item.SessionUID; }
}